import { getFirestore, doc, getDoc, collection, setDoc } from 'firebase/firestore';
import { firebaseConfig } from "../components/constants";
import { initializeApp } from "firebase/app";
import { getDocs } from 'firebase/firestore';


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export const fetchStories = async (lang: string): Promise<{ [key: string]: any }> => {
    if (lang !== 'it') {
        return {};
    }
    // Firestore collection "stories_it" contains a list of titles (document)
    // Each document contains a dictionary with properties like "link":
    // Get list of titles with corresponding links in a dictionary
    const storiesRef = collection(db, 'stories_'+lang);
    const storiesSnapshot = await getDocs(storiesRef);
    const storiesList: { [key: string]: any } = {}; // Add type annotation
    storiesSnapshot.forEach((doc) => {
        storiesList[doc.id] = doc.data();
    });
    
    return storiesList;
};
